import { AiOutlineFileExcel, AiOutlineFileImage, AiOutlineFilePpt, AiOutlinePlayCircle } from "react-icons/ai"
import { FaFileWord } from "react-icons/fa"
import { VscFilePdf } from "react-icons/vsc"

export const getIconDoc = fileName =>{
    let ext = ''
    if(fileName.split(".").length > 1) ext = fileName.split(".")[1].toLowerCase()

    switch(ext){
        case 'png':
            return <AiOutlineFileImage className="font-size-15rem color-green" />
        case 'jpg':
            return <AiOutlineFileImage className="font-size-15rem color-green" />
        case 'jpeg':
            return <AiOutlineFileImage className="font-size-15rem color-green" />
        case 'heic':
            return <AiOutlineFileImage className="font-size-15rem color-green" />
        case 'pdf':
            return <VscFilePdf className="font-size-15rem color-red" />
        case 'docx':
            return <FaFileWord className="font-size-15rem text-primary" />
        case 'pptx':
            return <AiOutlineFilePpt className="font-size-15rem text-danger" />
        case 'mp4':
            return <AiOutlinePlayCircle className="font-size-15rem text-primary" />
        case 'xls':
            return <AiOutlineFileExcel className="font-size-15rem color-green" />
        default: 
            return ''
    }

    
}